import { Box, Stack, Typography } from "@mui/material";
import dayjs from "dayjs";
import EditOrderInCalendarButton from "../../shared/EditOrderInCalendarButton";
import { OrderInfo } from "../../shared/orderInfo/types";

const STATUS_STYLES: { [key: string]: { color: string; backgroundColor: string } } = {
  Canceled: { color: "#ca0000", backgroundColor: "rgba(199, 0, 0, 0.12)" },
  Hold: { color: "#ffa500", backgroundColor: "rgba(255, 165, 0, 0.12)" },
  Duplicate: { color: "#ffa500", backgroundColor: "rgba(255, 165, 0, 0.12)" },
  Pending: { color: "#0066ff", backgroundColor: "rgba(139, 196, 248, 0.8)" },
  Closed: { color: "#ffde00", backgroundColor: "rgb(254, 255, 175)" },
  default: { color: "rgb(57, 181, 74)", backgroundColor: "rgb(57, 181, 74, 0.12)" }
};

const CAPTION_TEXT: { [key: string]: string } = {
  Closed: "Closed on",
  Completed: "Completed on",
  "In process": "Est. closing date",
  Firm: "Scheduled to close",
  Adjourned: "Adjourned from",
  Tentative: "Tentative Closing date",
  default: "Settlement date"
};

const StatusAndDate = ({ order }: { order: OrderInfo }) => {
  const { status, settlementDate, number } = order;
  const formattedDate = settlementDate ? dayjs(settlementDate).format("MM/DD/YYYY") : "--";
  const statusRequiresBox = ["Canceled", "Hold", "Transferred", "Duplicate"].includes(status);
  if (statusRequiresBox) {
    return (
      <Box
        sx={{
          borderRadius: "4px",
          textTransform: "uppercase",
          textAlign: "center",
          paddingRight: 1,
          paddingLeft: 1,
          ...(STATUS_STYLES[status] || STATUS_STYLES.default)
        }}
      >
        <Typography variant="subtitle2">{status}</Typography>
      </Box>
    );
  }

  const useRowLayout = ["Closed", "Completed", "In process", "Firm"].includes(status);
  const captionText = CAPTION_TEXT[status] || CAPTION_TEXT.default;

  return (
    <Stack direction={useRowLayout ? "row" : "column"} alignItems={useRowLayout ? "center" : "flex-start"}>
      <Box>
        <Typography variant="caption">{captionText}</Typography>
        <Typography variant="subtitle1">{formattedDate}</Typography>
      </Box>
      <EditOrderInCalendarButton orderNumber={number} />
    </Stack>
  );
};

export default StatusAndDate;
